<template>
  <base-button class="btn-primary" text="絞込" />
</template>

<script>
import BaseButton from '@/views/atoms/BaseButton';

export default {
  name: 'FilterButton',
  components: {
    BaseButton,
  },
}
</script>
